import state from '@/store/modules/plan/state'
import actions from '@/store/modules/plan/actions'
import mutations from '@/store/modules/plan/mutations'
import getters from '@/store/modules/plan/getters'

export default {
  state,
  actions,
  mutations,
  getters
}
